import { css } from '@emotion/react';
import {
  halfSpacing,
  quarterSpacing,
} from 'styles/global_defaults/scaffolding';
import { gray2, gray6, success, white } from 'styles/global_defaults/colors';
import { textSmallLineHeight } from 'styles/global_defaults/fonts';
import { useContext } from 'react';
import { CellProps } from './types';
import { commonStyles } from './styles';
import { DEFAULT_CONCURRENT_MENTOR_CONNECTION } from '../../constants';
import MentoringProgramContext from '../../context';

const styles = (hasAvailability: boolean) => css`
  ${commonStyles};

  .available-amount {
    color: ${gray2};
    background: ${gray6};
    border-radius: ${quarterSpacing}px;
    line-height: ${textSmallLineHeight}px;
    padding: ${quarterSpacing}px ${halfSpacing}px;

    ${hasAvailability
    && css`
      color: ${white};
      background: ${success};
    `}
  }
`;

const AvailabilityCell = (props: CellProps) => {
  const { cell, className } = props;
  const { row } = cell || {};
  const { original: mentoringProgramEnrollment } = row || {};
  const {
    concurrentMentorConnection = DEFAULT_CONCURRENT_MENTOR_CONNECTION,
    assignedConnections = [],
  } = mentoringProgramEnrollment || {};
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { mentorCapacityEnabled, concurrentMentorConnection: maxMentees } = mentoringProgram || {};

  const getAvailability = () => {
    const availability = (mentorCapacityEnabled ? concurrentMentorConnection : maxMentees)
      - assignedConnections.length;
    return availability < 0 ? 0 : availability;
  };

  return (
    <div
      className={`d-flex align-items-center ${className}`}
      css={styles(getAvailability() > 0)}
    >
      <div className='text-regular semi-bold available-amount'>
        {getAvailability()}
      </div>
    </div>
  );
};

export default AvailabilityCell;
